import {Controller} from "@hotwired/stimulus";

export default class PlanBillingReportFormController extends Controller {
  connect() {
    console.debug("Hello, Plan Billing Report Form", this.element);
    this.onPaymentStatusChanged();
  }

  onFormChanged(e) {
    console.debug('Form Changed', e);

    if (e.target.name === 'plan_billing_report[payment_status]') {
      this.onPaymentStatusChanged();
    }
  }

  onPaymentStatusChanged() {
    if (this.paymentStatus.value === 'paid') {
      this.paymentDateContainer.style.display = 'block';
    } else {
      this.paymentDateContainer.style.display = 'none';
    }
  }

  get paymentStatus() {
    return this.element['plan_billing_report[payment_status]'];
  }

  get paymentDateContainer() {
    return this.element['plan_billing_report[payment_date]'].parentNode;
  }
}
